import React, { useEffect } from 'react';

// Components
import Button from '../utils/formElements/button';
import IconSadFace from '../utils/icons/sadFace';

// Metrics
import { apaAnalytics } from '../../helpers/utils';

// CSS
import './invalidOffer.css';

const InvalidOffer = () => {
  const redirect = (e) => {
    e.preventDefault();
    window.top.location.href = 'https://campanha.assinanterbs.com.br/assinaturas-gauchazh/';
  };

  useEffect(() => {
    // Extract offerId from URL
    const urlPath = document.location.pathname;
    const initialIndex = urlPath.indexOf('/oferta/') + '/oferta/'.length;
    const finalIndex = urlPath.indexOf('/', initialIndex);
    const offerId = urlPath.substring(initialIndex, finalIndex);

    // Send metrics to GA4
    apaAnalytics({
      event: 'invalidOffer',
      offerId
    });
  }, []);

  return (
    <div className="invalid-offer-container">
      <IconSadFace fill="#d15239" />
      <h1>Bah...</h1>
      <p>Tentamos, mas não encontramos a oferta que procuras...</p>
      <Button
        type="button"
        text="Ver ofertas disponíveis"
        onClickHandler={e => redirect(e)}
        qaId="button-see-available-offers"
      />
    </div>
  );
};

export default InvalidOffer;
